import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { exposedApi } from '../../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';
import DebitNoteDetail from './DebitNoteDetail';

const DebitNotePrint = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [debitNoteData, setDebitNoteData] = useState({});

  const getDebitNoteData = () => {
    try {
      setIsLoading(true);
      exposedApi(`/exposed/inv/debit-notes/${params.id}`).then((res) => {
        const Data = res.data[0];
        setDebitNoteData(Data);
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getDebitNoteData();
  }, []);

  return (
    <>
      <ToastContainer />
      {isLoading ? <Spinner animation="border" variant="info" /> : <DebitNoteDetail data={debitNoteData} isPrint={true} />}
    </>
  );
};

export default DebitNotePrint;